import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Stack, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useEffect } from 'react';
import { useRef } from 'react';

export const RoomMasterInfoForm = ({ onAdd, onClose, setAddDetailsDialogue }) => {
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                room_no: Yup.string().required(' ')
            })
        ),
        defaultValues: {
            occupy_status: "F",
            cradle_charge: 'No',
            status: 'active'
        },
        mode: 'all'
    });
    const { handleSubmit, reset } = methods;
    const bedNoRef = useRef();


    const formSubmit = (formValue) => {
        onAdd(formValue);
        reset();
        if (bedNoRef.current) {
            bedNoRef.current.focus();
        }
    };

    useEffect(() => {
        if (bedNoRef.current) {
            bedNoRef.current.focus();
        }
    }, []);


    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
                <Typography sx={{ flex: 0.4 }}>Room No.</Typography>
                <TextField sx={{ flex: 0.6 }} name="room_no" placeholder="Enter Room No." inputRef={bedNoRef} />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                    Add
                </Button>
                <Button color="error" onClick={() => setAddDetailsDialogue(false)}>
                    Close
                </Button>
            </Stack>
        </FormProvider>
    );
};
